import http from '../../../../../../libs/http'
const api = `${process.env.VUE_APP_MICROSERVICE_API_SECURITY}/group`
export default (idGroup, payload = { action: '', state: true }) => http.put(`${api}/${idGroup}`, payload)
